export default function WebGLViewer() {
  return (
    <iframe
      id="webgl-frame"
      src="/media/MHI_Warehouse/riverstone_warehouse.html"
      title="MHI Warehouse 3D"
      style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
    />
  );
}
